import React from "react";
import "./SeoContentSection.css";

const SeoContentSection = ({ title, children }) => {
  return (
    <section className="seo-content-section">
      <div className="seo-content-inner">
        <h2>{title}</h2>
        {children}
      </div>
    </section>
  );
};

export default SeoContentSection;
